export interface Feature {
    name: string;
    free: boolean;
}

export const FEATURES: Feature[] = [
    {name: 'UTM URLs Builder Tool', free: true},

    {name: 'UTM URLs Management', free: true},

    {name: 'UTM Parameters Management', free: true},

    {name: 'UTM Templates Management', free: false},

    {name: 'Shorten UTM URLs with 1 Click', free: false},

    {name: 'Built-in 2Link.In Shortener', free: false},

    {name: 'URLs Stats and Analytics', free: false},

    {name: 'Unlimited Team Members', free: false},

];